import { AxiosRestService } from './AxiosRestService';

const rest = new AxiosRestService();

export class ShippingMethodService {
  list(): Promise<any[]> {
    return rest.get('shipping-methods');
  }

  getById(id: string): Promise<any> {
    return rest.get(`shipping-methods/${id}`);
  }

  create(body: any): Promise<any> {
    return rest.post('shipping-methods', body);
  }

  update(id: string, body: any): Promise<any> {
    return rest.put(`shipping-methods/${id}`, body);
  }

  delete(id: string): Promise<any> {
    return rest.delete(`shipping-methods/${id}`);
  }

  reorder(orderedIds: string[]): Promise<any> {
    return rest.put('shipping-methods/reorder', orderedIds);
  }

  getCarriers(): Promise<any[]> {
    return rest.get('shipping-methods/carriers');
  }

  getServices(carrierCode: string): Promise<any[]> {
    return rest.get(`shipping-methods/carriers/${encodeURIComponent(carrierCode)}/services`);
  }
}

export const shippingMethodService = new ShippingMethodService();
